import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-5 mb-2"
}
const _hoisted_2 = { class: "self-stretch justify-start items-center gap-3 inline-flex" }
const _hoisted_3 = { class: "grow shrink basis-0 text-racq-dark-grey text-lg-bold" }
const _hoisted_4 = {
  key: 0,
  class: "self-stretch justify-start items-start gap-3 inline-flex"
}
const _hoisted_5 = { class: "grow shrink basis-0 text-racq-dark-grey text-sm" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  key: 0,
  class: "self-stretch mb-2 flex flex-col md:block gap-4"
}
const _hoisted_8 = {
  key: 0,
  class: "self-stretch text-paragraph-color text-base break-words"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "w-100 flex items-center justify-center mb-5 gap-4" }

import { ref, computed } from 'vue';
import { IReviewSummary, IReviewSummaryItem } from '@/interfaces';
import ReviewSummaryItem from '@/components/ReviewSummary/ReviewSummaryItem.vue';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';
import ShowHideButton from '@/components/ShowHideButton/ShowHideButton.vue';
import { useFormStore } from '@/store';
import { Text, RichText, Link, Field } from '@sitecore-jss/sitecore-jss-vue';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewSummary',
  props: {
    reviewSummaries: {},
    isConfirmationStep: { type: Boolean },
    disableExpandToggle: { type: Boolean },
    showDiscounts: { type: Boolean },
    title: {},
    summaryItemFooterOnLastSummaryOnly: { type: Boolean },
    startExpanded: { type: Boolean },
    isSelfService: { type: Boolean },
    heading: {},
    belowHeading: {},
    subheading: {},
    outerClass: {}
  },
  emits: ["editClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const formStore = useFormStore();
const expanded = ref<boolean>(props.startExpanded ?? false);
const showMoreButton = computed(
  () => props.isConfirmationStep && !props.disableExpandToggle && props.reviewSummaries?.length > 1
);

// Exposed to track which "edit" link was clicked from the ReviewSummary
const emit = __emit;
function onEditDetails(goToStep: number, reviewSummary: IReviewSummary, reviewSummaryItem: IReviewSummaryItem) {
  formStore.clearLastStepSubmitted();
  emit('editClicked', reviewSummary, reviewSummaryItem);
  formStore.goToStep(goToStep);
}

/**
 * Returns whether the reviewSummaryItemContent contains a slot item
 * @param reviewSummaryItemContent The ReviewSummaryItemContent to check.
 */
function shouldRenderMapSlot(reviewSummaryItemContent: string): boolean {
  if (reviewSummaryItemContent?.includes('#googleMapWithPinStatic')) {
    return true;
  }
  return false;
}

function formatLink(url: string): LinkField {
  formStore.clearLastStepSubmitted();
  return {
    value: {
      href: url,
      target: '_self',
    },
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["max-w-176", _ctx.outerClass])
  }, [
    (_ctx.heading?.value || _ctx.belowHeading?.value || _ctx.subheading?.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (_ctx.heading?.value)
              ? (_openBlock(), _createBlock(_unref(Text), {
                  key: 0,
                  field: _ctx.heading,
                  class: "text-xl-bold mb-2",
                  tag: "h4"
                }, null, 8, ["field"]))
              : _createCommentVNode("", true),
            (_ctx.belowHeading?.value)
              ? (_openBlock(), _createBlock(_unref(Text), {
                  key: 1,
                  field: _ctx.belowHeading,
                  class: "text-base",
                  tag: "p"
                }, null, 8, ["field"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.subheading?.value)
            ? (_openBlock(), _createBlock(_unref(Text), {
                key: 0,
                field: _ctx.subheading,
                class: "text-base-bold uppercase",
                tag: "h5"
              }, null, 8, ["field"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["border-racq-pale-blue-border flex flex-col basis-full shadow-md bg-racq-true-white", {
        'rounded-b-none border-b-0 pt-6 pb-0': showMoreButton.value,
        'py-6': !showMoreButton.value,
        'rounded border-2': !_ctx.isSelfService,
        'rounded-lg border-[1.5px]': _ctx.isSelfService,
      }])
    }, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.title.value)
              ? (_openBlock(), _createBlock(_unref(Text), {
                  key: 0,
                  field: _ctx.title,
                  class: _normalizeClass(["px-8 text-xl-bold text-racq-dark-grey", { 'pb-6': !_ctx.isSelfService }]),
                  tag: "div"
                }, null, 8, ["field", "class"]))
              : (_ctx.title?.value !== '' && _ctx.title)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["px-8 text-xl-bold text-racq-dark-grey", { 'pb-6': !_ctx.isSelfService }])
                  }, _toDisplayString(_ctx.title), 3))
                : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewSummaries, (summary, sumIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: sumIndex,
          class: _normalizeClass(["self-stretch px-5 md:px-8 border-racq-pale-blue-border flex-col justify-start items-start gap-2.5 flex", {
          'border-b': (!showMoreButton.value || expanded.value) && sumIndex != _ctx.reviewSummaries.length - 1,
          hidden: !(
            (summary.fields?.items ?? summary.items).length &&
            (!_ctx.isConfirmationStep || _ctx.disableExpandToggle || sumIndex == 0 || expanded.value)
          ),
          'pt-5': sumIndex > 0,
          'pb-5': (!showMoreButton.value || expanded.value) && sumIndex != _ctx.reviewSummaries.length - 1,
        }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{
            'pb-3! gap-2':
              summary.summaryTitle?.value?.length !== 0 ||
              summary.fields?.summaryTitle ||
              summary.fields?.summarySubTitle ||
              summary.summarySubTitle?.value?.length !== 0,
          }, "self-stretch pb-0 flex-col justify-start items-start flex"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              (summary.fields?.icon?.value ?? summary.icon?.value)
                ? (_openBlock(), _createBlock(BaseIcon, {
                    key: 0,
                    iconClass: (summary.fields?.icon ?? summary.icon)?.value
                  }, null, 8, ["iconClass"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Text), {
                  field: summary.fields?.summaryTitle ?? summary.summaryTitle
                }, null, 8, ["field"])
              ])
            ]),
            (summary.fields?.summarySubTitle || summary.summarySubTitle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(RichText), {
                      field: summary.fields?.summarySubTitle ?? summary.summarySubTitle
                    }, null, 8, ["field"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["self-stretch flex-col justify-start items-start flex border-racq-pale-blue-border", {
            'border-b pb-5': showMoreButton.value && !expanded.value,
            'gap-2.5': !_ctx.isSelfService,
            'gap-3': _ctx.isSelfService,
          }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.fields?.items ?? summary.items, (item, itemIndex) => {
              return (_openBlock(), _createBlock(ReviewSummaryItem, {
                key: itemIndex,
                item: item,
                isLastReviewSummaryItem: itemIndex === (summary.fields?.items ?? summary.items).length - 1,
                isSelfService: _ctx.isSelfService
              }, _createSlots({
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(RichText), {
                      field: item.fields?.title ?? item.title,
                      class: "text-racq-dark-grey text-base-bold"
                    }, null, 8, ["field"])
                  ])
                ]),
                content: _withCtx(() => [
                  _createVNode(_unref(RichText), {
                    field: item.fields?.content ?? item.content,
                    class: _normalizeClass(["text-base", {
                  'text-block': !_ctx.isSelfService,
                }])
                  }, null, 8, ["field", "class"]),
                  (shouldRenderMapSlot(item.fields?.content?.value ?? item.content?.value))
                    ? _renderSlot(_ctx.$slots, "googleMapWithPinStatic", { key: 0 })
                    : _createCommentVNode("", true)
                ]),
                secondaryLinks: _withCtx(() => [
                  (
                  (item.showFirstLink === undefined || item.showFirstLink === true) &&
                  item.fields?.firstLink?.value.text
                )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                        (item.fields.firstLink?.value?.href)
                          ? (_openBlock(), _createBlock(_unref(Link), {
                              key: 0,
                              field: item.fields.firstLink,
                              class: "text-m-bold mr-4"
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        (item.fields.secondLink?.value?.href)
                          ? (_openBlock(), _createBlock(_unref(Link), {
                              key: 1,
                              field: item.fields.secondLink,
                              class: "text-m-bold"
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                edit: _withCtx(() => [
                  (
                  (item.showPrimaryLink === undefined || item.showPrimaryLink === true) &&
                  item.fields?.primaryLink?.value?.href
                )
                    ? (_openBlock(), _createBlock(_unref(Link), {
                        key: 0,
                        field: item.fields.primaryLink,
                        class: "link text-base-bold"
                      }, null, 8, ["field"]))
                    : _createCommentVNode("", true),
                  (item.editUrl && !_ctx.isConfirmationStep && item.showEdit)
                    ? (_openBlock(), _createBlock(_unref(Link), {
                        key: 1,
                        field: formatLink(item.editUrl),
                        class: "text-base-bold underline"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("Edit")
                        ])),
                        _: 2
                      }, 1032, ["field"]))
                    : _createCommentVNode("", true),
                  (item.editGoToStep != null && !_ctx.isConfirmationStep && item.showEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "link text-base-bold",
                        onClick: ($event: any) => (onEditDetails(item.editGoToStep, summary, item))
                      }, " Edit ", 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, [
                (item.name !== '')
                  ? {
                      name: "subContent",
                      fn: _withCtx(() => [
                        _renderSlot(_ctx.$slots, `subContent-${item.name}`),
                        (
                  (item.showSubcontent === undefined || item.showSubcontent === true) && item.fields?.subcontent?.value
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("div", {
                                innerHTML: item.fields.subcontent.value
                              }, null, 8, _hoisted_9)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["item", "isLastReviewSummaryItem", "isSelfService"]))
            }), 128)),
            (
              !_ctx.summaryItemFooterOnLastSummaryOnly ||
              (_ctx.summaryItemFooterOnLastSummaryOnly && sumIndex === _ctx.reviewSummaries.length - 1)
            )
              ? _renderSlot(_ctx.$slots, "summaryItemFooter", { key: 0 })
              : _createCommentVNode("", true)
          ], 2)
        ], 2))
      }), 128)),
      (_ctx.showDiscounts || !_ctx.isConfirmationStep || expanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _renderSlot(_ctx.$slots, "additionalPeople"),
            _renderSlot(_ctx.$slots, "policyDiscounts"),
            _renderSlot(_ctx.$slots, "ssPolicyDiscounts")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (showMoreButton.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{
        'border-t-0': !expanded.value,
        'rounded border-2': !_ctx.isSelfService,
        'rounded-lg border-[1.5px]': _ctx.isSelfService,
      }, "border-racq-pale-blue-border flex flex-col basis-full border-t-0 rounded-t-none bg-white"])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(ShowHideButton, {
              showMore: expanded.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
            }, null, 8, ["showMore"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})